import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -70% 0px',
      threshold: 0
    };

    const sections = document.querySelectorAll("main h2[id]");
    const tocLinks = document.querySelectorAll(".toc-link");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          tocLinks.forEach((link) => {
            link.classList.remove("font-bold", "text-gray-950");
            if (link.dataset.target === id) {
              link.classList.add("font-bold", "text-gray-950");
            }
          });
        }
      });
    }, observerOptions);

    sections.forEach((section) => observer.observe(section));
  }
}
